module.exports = require("core-js/modules/es.typed-array.join.js");